import { collection, doc, getDoc, getDocs } from 'firebase/firestore/lite';
import { BUSINESS, CONFIG, DEFAULT, PUBLICITY_DESKTOP, PUBLICITY_MOBIL, TOP_PUBLICITY } from '../data/parameters';
import {
    db
} from '@/firebase';
const geofire = require("geofire-common");

function generateGeoHash(location: [number, number]) {
    const hash = geofire.geohashForLocation(location);
    return hash;
}

async function getPublicityTop(id_city: string) {
    return [];
    try {
        let publicity = await getDocs(collection(db, BUSINESS, id_city, TOP_PUBLICITY));
        let result: Array<any> = []
        publicity.forEach(doc => {
            result.push(doc.data());
        });
        return result;
    } catch (error) {
        console.log('Error:', error);
        return []
    }
}

async function getPublicityMobil(id_city: string) {
    return [];
    try {
        let publicity = await getDocs(collection(db, BUSINESS, id_city, PUBLICITY_MOBIL));
        let result: Array<any> = []
        publicity.forEach(doc => {
            result.push(doc.data());
        });
        return result;
    } catch (error) {
        console.log(error);
        return []
    }
}

async function getPublicityDesktop(id_city: string) {
    return [];
    try {
        let publicity = await getDocs(collection(db, BUSINESS, id_city, PUBLICITY_DESKTOP));
        let result: Array<any> = []
        publicity.forEach(doc => {
            result.push(doc.data());
        });
        return result;
    } catch (error) {
        console.log(error);
        return []
    }
}

async function getDefault() {
    try {
        let default_data = await getDoc(doc(db, CONFIG, DEFAULT));
        return default_data.data();
    } catch (error) {
        console.log(error);
        return []
    }
}

export {
    getPublicityTop,
    getPublicityMobil,
    getPublicityDesktop,
    getDefault,
    generateGeoHash
}